// Source: https://fullylived.com/bucket-list-ideas/

export default `
# Health & Fitness Bucket Ideas
Accomplish Three Pull-Ups
Achieve Six-Pack Abs
Achieve my Ideal Weight
Be Able to Do a One-Handed Push Up
Be Able to Do a Backflip
Be Able to Do a Roundhouse Kick
Be Able to Do the Splits
Be Able to Do Half Moon Yoga Pose
Be in an Amateur Bodybuilding Competition
Be Fitter Then Ever
Become a Black Belt in Karate
Become a Size 10
Become a Bodybuilder
Benchpress my Own Weight
Become a Triathlete
Bike Across the Country
Climb a Rock Wall
Bike to Another Town
Compete in a 3-Point Basketball Contest
Climb a Spiral Staircase
Compete in a Fitness Competition
Compete in an Archery Tournament
Compete in a Surf Competition
Compete in Tough Mudder
Compete in the Olympics
Complete 4-hr Body Challenge
Complete 90 Days of P90X
Complete 60-Day Insanity Transformation
Complete a 10K Run
Complete a 10K Competitive Run Race
Complete a 30-Day Juice Fast
Complete a 5K Run
Complete a 5K Competitive Run Race
Complete a Cross-Country Ski Race
Complete a Course in Something
Complete a Dakar Rally
Complete a Marathon
Complete a Half-Marathon
Complete an Ironman Triathlon
Complete a Sprint Distance Triathlon
Complete an Ultra Marathon
Complete Open Water Dive Certification
Complete Ironman Kona
Complete the Body For Life Challenge
Complete the 100 Push-Up Challenge
Complete the Seven Summits
Deadlift 500 Pounds
Completely Give Up Fast Food For a Month
Do "Insanity" Fitness Program
Design An Individual Yoga Experience
Do 10 Pushups for 10 Days
Do 100 Sit-Ups in 5 Minutes
Do 100 Kettlebell Swings in One Shot
Do a 180 While Skiing
Do 25 Straight Pull-ups
Do a Backflip
Do a Body Suspension
Do a Base Jump
Do a Full Split
Do a Double Frontflip
Do a Handstand
Do a Warrior Dash-Type Run
Do a Juice Fast
Down Hill Biking
Dog Sledding
Drink 3 Glasses of Water First Thing in the Morning
Drop 15 Kilos This Year
Drink Only Water For a Year
Enter the Tough Guy Competition
Enter the Cooper Hill Cheese Roll
Enter the World Bog Snorkeling Championships
Exercise Daily in the Morning
Exercise 4 Times a Week
Exercise Until I Can't
Exercise For 3 Months
Find a Sport I Love and Get Good at It
Finish a Half-Ironman Competition
Find a Training Buddy
Finish the 60-Day Insanity Workout
Finish First Place
Get 6-Pack Abs
Get Better at Basketball
Get a Strike in Bowling
Go a Week Drinking Only Water
Get Down to 60Kg
Go a Whole Season Without Missing a Liverpool Game
Go Curling
Go Abseiling Down a Mountain
Go Deep Sea Diving
Go Dancing
Go For Walk in Central Park
Go Ice Skating
Go Hiking
Go Kiteboarding
Go Kayaking
Go Mountain Climbing
Go on a Midnight Bike Ride
Go on a Health Retreat
Go Rock Climbing with My Best Friend
Go Paddle Boarding

# Personal Development Bucket Ideas
Achieve 1,000 Goals
Act on my Fears
Achieve Happiness
Add a Video to All My Completed Items
Add a Picture of all my Goals
Attend a 10-Day Vipassana Meditation Course
Attend a Yoga Class
Attend a Poetry Reading
Attend a Tony Robbins' Event
Attend an Inner Awakening Retreat
Be a Mentor to Someone
Be Part of Habitat for Humanity
Be Part of an Important Movement
Be a True Inspiration to Someone
Be a Regular Blood Donor
Be a Volunteer Baby Cuddler
Be an Activist
Be a Volunteer in an Association
Be at Peace with my Body
Be an Inspiration to Someone
Be Blind For a Day
Be Myself
Be Honest About Everything in Life
Be Part of a Disaster Relief Team
Be on Stage in Front of Thousands of People
Be Part of a Peaceful Protest
Be Self-Sufficient
Be Passionate About a Cause
Beat Cancer
Be Someone's Hero
Become a Better Public Speaker
Become a Potential Bone Marrow  Donor
Become a Blood Donor
Become Courageous
Become an Early Riser
Become the First Woman President
Become Less Materialistic
Become Influential
Become More Organized
Become More Enthusiastic
Become Optimistic
Break a Bad Habit
Learn to Love Yourself
Build a Center for Child Development
Break a Guinness World Record
Build A Community of Like-Minded People
Build Schools For Women and Girls in Developing Countries
Build a Healthier America
Pay for a Stranger's Meal at a Restaurant
Buy a Cup of Coffee for a Cold Salvation Army Bell Ringer
Buy a Stranger's Groceries
Change Your "Story" to What You Want Your Life to Be
Care Less About What People Think
Change at Least One Person's Mind About Gay Rights
Change as Many Lives as You Can
Change Someone's Life for the Better
Complete 26 Random Acts of Kindness
Change Someone's Point of View
Complete a 30-Day Challenge
Complete 500 Things on your Bucket List
Complete a 365-Day Photo Challenge
Completely "Unplug" For a Week
Complete Half the Items on Your Bucket List
Conquer Insomnia
Conquer Fear of Snakes
Conquer My Fear of Heights
Create a Balanced Life
Convince Someone to Change Religions
Create a Place for People to Find Purpose
Create a New Standard
Create a Travel Journal
Donate Your Hair
Create a Self-Study Program
Dance Like No One's Watching
Cut Out Sugar for a Month
Decide on My Biggest Goal This Year
Develop My Intuition
Define My Own Utopia
Discover My Natural Talent
Discover My Life's Purpose
Discover What Makes Me Happy
Do a Buddha Meditation
Do 365 Random Acts of Kindness in a Year
Stay Silent for 24 Hours
Do a Favor for a Stranger on the Scale of "Pay It Forward"
Do Charity Work Abroad
Do Dishes Every Night
Do Charity Work with Animals
Do Something New Every Month for a Year
Do Something Crazy for Charity
Do Something Nice for a Person Who's Homeless
Do Something People Say I Can't Do
Do Something Nice for Someone Who Will Never Find Out
Donate a Large Sum of Money
Donate $100 to Charity
Donate Blood
Donate Clothes I No Longer Use
Donate an Organ
Donate Items to a Nonprofit Organization
Donate Every Christmas to a Community Group

# Travel Bucket List Ideas
Add a Lock to Lovers Bridge in France
Coast-to-Coast Road Trip
Coast-to-Coast Train Trip
Couchsurf While Traveling
Couchsurf in 10 Countries
Cross the Canadian Border
Cross the Nile River
Cross the Equator
Cross the USA by Car
Cross the Panama Canal
Cross-Country Road Trip
Cruise Around the Whitsundays
Take a Cross-Country Road Trip with Friends
Cruise Mexico
Cruise Around the World
Cruise the Caribbean
Cruise to Alaska
Cruise the South Pacific Islands
Do an Antarctic Tour
Cruise to Antarctica
Do an Everglades Tour
Do Handstands All over the World
Do an Interrail Trip
Run with the Bulls in Pamplona
Hike the Appalachian Trail
Do the Camino De Santiago in Spain
Do the Great New Zealand Bike Ride
Do the Grand Southern Trip - LA to NY
Do the Inca Trail to Machu Picchu
Do the Great Victorian Bike Ride
Do the Red Paperclip Challenge
Drive Across the Golden Gate Bridge
Drive Across Canada in an RV
Drive Along Route 66
Drive Across Western Europe
Drive Along the Great Ocean Road
Drive Around Australia
Drive Along the Pacific Coast Highway
Drive the Hawaiian Coast
Drive from Home to the East Coast
Experience the Grand Canyon
Explore Africa
Experience the Living Root Bridges
Explore Australia and New Zealand
Explore Asia and the Far East
Explore Chernobyl
Explore Europe
Explore Ethiopia
Explore L'Aquatic Paradis in Barcelona
Explore Kauai
Explore Manhattan
Take the Trans-Siberian Railroad
Explore Petra
Explore the Amazon Rainforest
Explore Shivering Sands Army Fort
Explore the Catacombs of Paris
Explore the Galapagos Islands
Explore the Desert on a Camel Safari in India
Get a Self-Portrait in Italy
Get a Lei in Hawaii
Get High in Amsterdam
Backpack Through Europe
Get Lost in a Foreign Country
Go for a Swim in the Blue Ocean in the Maldives
Go Clubbing in Miami
Go Hiking in Ireland
Go Horseback Riding in Texas
Go Horseback Riding in Swan Valley, Montana
Go on a Gondola in Venice
Go Husky Dog Sledding in Alaska
Go on a Mother-Daughter Vacation
Go on a Random Road Trip
Go on a Pilgrimage to Santiago De Compostela
Go on a Tour of the Gothic Cathedrals of Europe
Go on Safari in Africa
Go on a Tour of the Harry Potter Studio
Go to the Summer Olympics
See Nightwish in Finland
Go Shopping in New York
Go Shopping in Milan
Go Snorkeling in the Caribbean
Swim in the Dead Sea
Go Spelunking in the Ape Caves
Go to a Big Rock Concert Abroad
Go to a Big Medieval Fair
Go to a Big Time Movie Premiere in Hollywood
Go to an English Pub
Go to the Cherry Blossom Festival in Japan
Go to Barbados
Go to an International Football Tournament
Go to Bhutan
Go to Burning Man
Visit Brazil
Go to Colorado
Visit China During Chinese New Year
Go to Disney Land Paris
Go to Egypt
Go to Dollywood
Go to Florida
Go to Fern Canyon

# Business and Career Bucket Ideas
Apply to Be a Flight Attendant
Be Elected to Political Office
Ask for a Pay Raise
Be Recognized as an Authority in My Field
Be My Own Boss
Be the Sheriff of a Small Town
Become a Ballet Dancer
Be Time Magazine's Person of the Year
Become a Billionaire
Become a Bartender
Become a Certified Personal Trainer
Become a Cheese Connoisseur
Become a Certified Sky Diver
Become a Counselor at a Summer Camp in America
Become a Corporal in the Marine Corps
Become a Dancer
Become a Divemaster
Become a Dentist
Become a Dual Citizen
Become a Doctor
Become a Famous Business Women
Become a Farmer
Become a Famous Chef
Become a Freelance Writer
Become a Film Maker
Become a Full-Time Firefighter
Become a Good Horse Trainer
Become a Geologist
Become a Journalist
Become a Good Kick Boxer
Become a Judge
Become a Landlord
Become a Kindergarten Teacher
Become a Legend
Become a Lawyer
Become a Licensed Pilot
Become a Lifeguard
Become a Life Coach
Become a Master Marksman
Become a Martial Arts Instructor
Become a Memory Artist
Become a Millionaire
Become a Military Police Officer
Become a Nomad
Become a Model
Become a Nurse
Become a Paramedic
Become a Nurse in the Army
Become a Pharmacist
Become a Personal Trainer
Become a Philanthropist
Become a Photographer
Become a Politician
Become a Professional Athlete
Become a Priest
Become a Professional Cook
Become a Professional Dancer
Become a Professor
Become a Psychologist
Become a Programmer
Become a Psychotherapist
Become a Qualified Scuba Diver
Become a Published Author
Become a Registered Organ Donor
Become a Recognized Economist
Become a Registered Scientist
Become a Runway Model
Become a Reiki Master
Become a Sailboat Captain
Become a Sage
Become a Scratch Golfer
Become a Senator
Become a Scientist
Become a Special Education Teacher
Become a Sommelier
Become a Stamp Collector
Become a Supermodel
Become a Stand-Up Comedian
Become a Translator
Become a Teacher
Become a Travel Writer
Become a Very Successful Lawyer
Become a United Nations Interpreter
Become a Wildlife Photographer
Become a Voice Actor
Become a Wine Connoisseur
Become a Yoga Instructor
Become a World Renowned Artist
Become a Youth Sports Coach
Become a Yoga Master
Become a Zen Master
Become an Architect
Become an Accomplished Baker
Become an Attorney
Become an Art Collector
Become the Author of a Successful Blog
Become an Expert Scuba-Diver
Become an Entrepreneur
Become an Investigator
Become an Interior Designer

# Adventure Bucket Ideas
Abseil Down a Building
Abseil Down a Waterfall
Abseil Down a Rock Face
Arrive by Seaplane
Airboat Across an Alligator Infested Swamp
Backpack Across Europe
Backpack in the Himalayas
Backpack through South America
Backpack in South East Asia
Hike the Appalachian Trail
Backpack the Camino De Santiago
Backpack Through Wallowa National Forest
Backpack Through Hells Canyon
Backpack Across New Zealand
Backpack Across Australia
Camp and Sleep on Top of a Mountain
Camp at a Park
Camp at the Grand Canyon
Camp in an African Village
Camp in a Yurt
Camp in the Backyard
Camp in Yosemite Backcountry
Camp in Yellowstone National Park
Camp Out in the Sahara Desert
Camp on an Island
Camp Out in the Wilds
Camp Under the Northern Lights
Camp Overnight in the Wilderness
Canoe Down a River
Campervan Down the Coast
Canoe Down the Amazon River
Canoe the Amazon River
Canoe or Kayak the Chicago River
Climb a Glacier
Canoe the Whanganui River in New Zealand
Climb a Himalayan Mountain
Climb a Pyramid
Climb a Mountain
Complete All Bicycle Tracks in New Zealand
Climb a Rock Arch Over the Ocean
Complete Route 66 on a Motorcycle
Travel Cross Country by Train
Complete the Trip Che Guevara Made Through South America
Cross the Atlantic Ocean with a Sailboat
Cross over a Swinging Suspension Bridge
Cross the Australian Outback
Cross the Sahara
Cross the Bridge of the Immortals in China
Descend the Banaue Rice Terraces
Cycle from Lands End to John-O-Groates
Dive in the Green Lake, Austria
Dive Off Stari Most Bridge in Mostar, Bosnia
Dive Near the Mariana's Trench
Dive the Great Barrier Reef
Dive the Famous Blue Hole of Belize
Go Bamboo Rafting
Go Camping
Go Banana Boating
Go Camping at Litchfield National Park
Go Camping and Watch the Moonlight
Go Camping in the Outback
Go Camping with my Best Friends
Go Camping in Yosemite
Go Fishing in Montana
Go Canoeing
Go to Antarctica
Hike a Part of the Pacific Coast Trail
Have One Adventure a Month
Hike Algonquin (5114 ft)
Hike a Volcano
Hike all the 14-ers in Colorado
Hike Around a Volcano
Hike Arches National Park, Utah
Hike Basin (4827 ft)
Hike the Atlas Mountains in Morocco
Hike the Bay Ridge Trail
Hike Colden (4714 ft)
Hike Big Sur
Hike Down a Waterfall
Hike Dix (4857 ft)
Hike for Five Miles
Hike Gothics (4736 ft)
Hike Giant (4627 ft)
Hike in Alaska and Kiss Under the Northern Lights
Hike Gray (4840 ft)
Hike in Death Valley
Hike in Nepal
Hike in Gros Morne National Park
Hike in Yosemite National Park
Hike the Grand Canyon
Hike Machu Picchu
Hike the Mason Dixon Trail
Hike Marcy (5344 ft)
Hike Mount Doom
Hike Mont Blanc
Hike Mount Kilimanjaro
Hike on a Glacier
Hike Nippletop (4620 ft)
Hike Redfield (4606 ft)
Hike Part of the Appalachian Trail

# Food Bucket Ideas
Bake a Banana Cake
Bake a Cake For Someone Special
Bake a Cake For Someone For No Reason
Bake a Giant Cookie
Bake a Cheesecake
Bake a Layered Cake
Bake a New-York Cheesecake
Bake a Lemon Cake
Bake a Pizza from Scratch
Bake a Pie
Bake a Rainbow Cake
Bake Cupcakes
Bake Cinnamon Rolls
Bake my Own Bread
Bake Halloween Cookies
Cook 30 Recipes from 30 Different Countries in 30 Days
Cook a Full English Breakfast on a BBQ in the Sun
Cook a Chicken Curry
Cook a Holiday Meal
Cook a Good Dinner 4 Times a Week
Cook a Meal
Cook a Three Course Meal For a Group of Friends
Cook a Meal from Every Culture
Cook all the Recipes in a Cookbook
Cook a Turkey That You Shot For Thanksgiving
Cook an Entire Meal from Another Culture
Cook Dinner For Someone
Cook Christmas Dinner
Cook With a Celebrity Chef
Cook Dinner For the Whole Family
Cook With my Partner
Create my Own Recipe
Create a Secret Family Recipe
Eat a Belgium Waffle in Belgium
Eat a Bagel in NY
Eat a Crepe in France
Eat a Gourmet Meal
Eat a Croissant at a Cafe in Paris
Eat a Hot Dog in New York City
Eat a Gyro in Greece
Eat Lobster in Maine
Eat a Pastry Under the Eiffel Tower
Eat a Macaron in Paris
Eat a Soft Pretzel from a Cart in NYC
Eat a Six-Course Meal That I Prepared
Eat Traditional Food from Every Country
Eat Apple Strudel in Vienna, Austria
Eat Antipasto in Italy
Eat at One of Chef Gordon Ramsay's Restaurants
Eat at a German Bakery
Eat at One of the World's Best Restaurants
Eat at the Dans Le Noir in New York
Eat at the Best Sushi Restaurant in the World
Eat at the French Laundry
Eat at the Fat Duck
Eat at the Hard Rock Cafe
Eat at the Space Needle Tower in Seattle
Eat at the Heart Attack Grill in Las Vegas
Eat Breakfast, Lunch, and Dinner at D2
Eat at the Titanic Restaurant and Bar in Cork
Eat Brownies in Amsterdam
Eat Chinese Food in China
Eat Cajun Food in New Orleans
Eat Couscous in Morocco
Eat Chocolate in Belgium
Eat Cream Puffs at the Wisconsin State Fair
Eat Curry in India
Eat Crepes in France
Eat Fajitas in Mexico
Eat Escargot in France
Eat Fish and Chips in London
Eat French Cheese in France
Eat Fondue in Switzerland
Eat Gelato in Italy
Eat French Macaroons
Eat Grasshoppers in Thailand
Eat Healthy and Home Made Food
Eat Greek Salad in Greece
Eat at a White Castle Restaurant
Eat at a Michelin-Starred Restaurant
Eat Jellied Eels from a Stall in London
Eat Kangaroo in Australia
Eat Jocote
Eat Madeleines
Eat KFC in Kentucky
Eat Maple Syrup Pancakes in Canada
Eat New York Cheesecake in New York
Eat Mexican Food in Mexico
Eat Olives in Greece
Eat Noodles in Hong Kong
Eat Pasta in Italy
Eat Poi in Hawaii
Eat Pizza in Italy
Eat Ribs at an American BBQ
Eat Ramen in Japan
Eat Roasted Chestnuts on the Champs-Elysees
Eat Sushi in Japan
Eat Snails in Paris
Enter a Cooking Contest
Eat Using Chopsticks in Asia

# Financial Bucket Ideas
Be Completely Debt Free
Become a Business Owner
Be Debt Free in 10 Years
Buy Property Abroad
Become Financially Literate
Create Passive Income
Fill my Savings Jar
Establish my Business Before I Turn 40
Gain Financial Freedom
Free Myself from Debt
Gain Financial Security
Get Certified As a Financial Planner
Get an Investment Plan
Have $10,000 in Savings
Go an Entire Month Without Spending Any Money
Have a Net Worth of $1,000,000
Invest in a Business
Have a Positive Net Worth
Invest in Gold
Invest in a Stock
Invest in Real Estate
Invest in the Stock Market
Invest in Silver
Max Out a Credit Card
Make Loans to Entrepreneurs Through Kiva.Com
Obtain 500 Oz. of Silver
Pay For a New Car With Cash
Pay Back my Student Loan
Pay Off Library Fee
Pay For my College Education
Pay Off my Student Loan
Save $10,000
Put 3 Dollars in a Jar Every Single Day For One Year
Save $2,000
Save $100 from Coupons During a Grocery Store Purchase
Save For a House
Start a Side Photography Business
Start a Business
Win the Lottery
Stay on a Strict Budget and Save For a Goal

# Learning and Education Bucket Ideas
Achieve a 4.0 For One Semester
Attend a Presidential Inauguration
Add Something Useful to Wikipedia
Attend a TED Talk
Attend a Sydney Opera House Event
Attend a Writing Class
Attend Howard University
Attend California Institute of the Arts
Be a Foreign Exchange Student
Attend Stanford Law School
Become Bilingual
Become Fluent in French
Become Fluent in Dutch
Become Fluent in German
Become Fluent in French and Spanish
Become Fluent in Italian
Become Fluent in Spanish
Become Fluent in Mandarin Chinese
Complete a 5000 Question Survey
Build An Educational Institute
Complete a Course to Become a Photographer
Complete a Management Course
Complete a Degree
Complete a Novel
Complete a Master's Degree
Complete a Rubik's Cube
Read all of my Favorite Author's Books
Give a Talk to a Class of Students
Complete an Art Foundation Course in London
Read all the Books from '1001 Books You Must Read Before You Die'
Complete an Instagram Month Challenge
Complete Another Degree
Complete an Online Class
Complete College
Complete at Least 3 Years of French Classes
Complete Final Year of Graduate School
Complete a Degree With Distinction
Complete a Bachelor's Degree
Complete an Honors Degree
Complete a Doctorate
Do a First Aid Course
Do a NOLS Course
Do a Course in Music
Do Crosswords Every Day For a Month
Do Research in Antarctica
Do Sudoku Every Day For a Year
Educate Others About Agriculture
Earn an M.B.A. Degree
Do a second Master's Degree
Fail a Course
Finish a Book in Spanish
Finish High school on Time
Finish First in my Class
Get a 10 For a Math's Test
Follow a Course For First Aid Training
Get a Racing License
Get a TEFL Qualification
Win a Scholarship For University
Get Better in Playing the Drums
Get Accepted to my Dream College
Get Certified As a Lifeguard
Get CPR Certified
Get Certified As a Public Accountant
Get Into a Private School
Get Good at the Guitar
Get Into Harvard
Get Into Med School
Get Into Law School
Get my Captains License
Get Into Vet School
Get my Degree in Teaching
Give a Commencement Speech
Get Straight A's Next Semester
Immerse myself in Buddhism
Go on a University Exchange
Improve my French
Join a Chess Club
Join a Book Club
Know the Stars
Know the Alphabet Backwards
Learn 100 Basic American Sign Language Signs
Learn a Burlesque Routine
Learn to Ballroom Dance
Learn a Computer Programming Language
Learn a Choreographed Dance
Learn a Dance
Learn a Form of Martial Arts
Learn a Foreign Language
Learn a Hilarious Phrase in 10 Languages
Learn a Form of Spanish Dancing
Learn a Magic Card Trick
Learn a New Language and Speak It Fluently
Learn a Magic Trick
Learn a New Word Every Day For a Year
Learn a New Sport
Learn a New Word from an Unknown Language Every Day For 30 Days
Learn a Trade
Learn a Song on the Ukulele
Study Hieroglyphics
Study a New Religion

# Relationship Bucket Ideas
Adopt a Child
Ask a Guy on a Date
Adopt Internationally
Ask Someone to the Prom
Ask Out a Hollywood Actress
Ask Someone to a Dance
Attend a Bat Mitzvah
Ask Someone You've Only Just Met Out on a Date
Attend a High School Reunion
Attend a Gay Pride Event
Attend One Wine Tasting a Month
Be a Foster Parent
Be a Bridesmaid
Be Cupid For a Couple Who Will End Up Married
Be a Godmother
Be Kissed By the Person I Love at Midnight on New Years
Be Proposed to in a Unique Way
Be Kissed Unexpectedly in the Middle of a Sentence
Become a Midwife
Become a Father
Become a Mom
Become Friends With a Celebrity
Become Friendly With Someone I Dislike
Become More Outgoing
Make Friends With a Stranger
Build a Blanket Fort With Someone I Love
Build a Cool Tree House For the Kids
Build a Snow Fort with Someone I love
Build Something That I Can Leave For my Kids
Build a Log Cabin for Me and My Wife
Calm an Extremely Angry Person
Carve my Love and my Name Into a Tree
Care For my Parents When They Are Old
Confess my Love
Confess my Feelings
Connect With an Old Friend
Create a New Family Tradition
Crack a Joke Making More Than 5 People Laugh at Once
Create a Tradition of Getting Together
Create a Social Enterprise
Cut Our First Child's Umbilical Cord
Date Someone from Another Culture or Background
Date a Beautiful Woman
Date a Model
Date a Doctor
Date a Rich Man
Date an Athlete
Date a Yoga Teacher
Devote an Entire Day to Sex
Date Someone my Mom Likes
Experience True Love
Fall Madly, Deeply in Love
Fall Asleep in my Boyfriend/Girlfriend's Arms
Fall in Love For a Night
Fall in Love Accidentally
Find "The One"
Fly Lanterns at my Wedding
Find a Husband
Get a Hot Boyfriend
Gaze at the Stars With Someone
Get a Mistletoe Kiss
Get Engaged
Get a New Years Kiss at Midnight
Have a Long Distance Relationship
Get Married
Go on a Blind Date
Go on a Date to the Beach
Go on a Date at an Amusement Park
Go on a Fancy Date
Go on a Double Date
Go on a Romantic Getaway
Go on a Date on Valentine's Day
Go on a Romantic Vacation to Paris
Go Out with a Beautiful Red Head
Go on an Ice Skating Date
Go to a Baby Shower
Grow Old with the Love of my Life
Go to a Garden Party
Celebrate your 50th Wedding Anniversary
Have 3 or More Kids
Have a Baby
Have a Boyfriend
Have a Beautiful Wedding
Have a Cup of Coffee With a Stranger
Have a Candle Lit Dinner
Have a Deep and Meaningful Conversation with a Celebrity
Be on Facebook
Have a Dramatic Public Argument
Have a Friend in a Different Country
Have a Foreign Girlfriend
Have a Girls Weekend Away With my Mum
Be in a Long-Term Relationship
Have a Large Family
Enjoy a Perfect Kiss
Have a Meaningful Conversation with a Stranger
Have a Picnic in Central Park, New York City
Have a Romantic Flight in a Hot Air Balloon
Have a Relationship That Is Successful for at Least a Year
Have a Second Child
Have a Roommate

# Fun Bucket Ideas
Adopt a Funny Accent For the Day
Apply to Be an Amazing Race Contestant
Apply to Be a Jeopardy Contestant
Attend a Ball
Attend a 3-Day Music Festival
Attend a Ballet
Attend a Big Rock Concert
Attend a Big Fashion Show
Attend a Boxing Match
Attend a Bonfire Party
Attend a Broadway Show
Attend a Charity Ball
Attend a Bull Fight
Attend a Circus Show
Attend a Chinese New Year
Attend a Cirque Du Soleil Show
Attend a College Football Game
Attend a Classical Concert
Attend a Concert As V.I.P
Attend a Concert
Attend a Cookery Class
Attend a Crocodile Show
Attend a Costume Party
Attend a Murder Mystery Dinner
Attend a Cultural Festival
Attend a European Nightclub
Attend a Fancy Dinner
Attend a Fancy Cocktail Party
Attend a Foam Party
Attend a Film Premiere
Attend a Football League Trophy Final
Attend the Oscars
Attend a Full Moon Beach Party
Attend a Hindu Wedding
Attend a Harlem Globetrotters Game
Attend a Japanese Tea Ceremony
Attend an Ethiopian Coffee Ceremony
Attend a Lantern Festival
Attend a Military Ball
Attend a Masquerade Ball
Attend a Murder Mystery
Attend a Party Under a Fake Name
Attend a Paint Party
Attend a Street Party
Attend a Rave
Attend Carnival
Go to the Monaco Grand Prix
Attend More Than 5 Festivals
Go to a Full Moon Party in Thailand
Have Front Row Seats at a Rock Concert
Be in a Jacuzzi in the Snow
Celebrate New Years Eve in Time Square, New York City
Be in a Small-Town Parade
Learn to Blow Smoke Rings
Have a Big Party for All my Friends
Build a Snowman Taller Than Me
Celebrate Bastille Day in France
Catch a Guitar Pick at a Concert
Celebrate St. Patrick's Day in Dublin, Ireland
Celebrate Beltane in Ireland
Celebrate the 4th of July in Washington DC
Go Clubbing in Ibiza
Dance an Argentine Tango
Dance in Bali
Dance at Carnival in Rio De Janeiro
Dance in Central Park
Dance in the Moonlight
Dance in the Macy's Thanksgiving Day Parade
Dance to Dubstep all Night
Dance Salsa in Rio Di Janeiro
Dance With an African Tribe
Do a Boudoir Photoshoot
Dine in the Dark
Drink a Glass of Red Wine in Chile
Drink a Beer in a Real Irish Pub
Drink Champagne in France
Drink Rum on a Caribbean Beach
Drink Guinness in Ireland
Drive a 4-Wheeler
Drink Tequila in Mexico
Drive a Car Without the Top On
Drive a Ferrari
Drive a Caterpillar
Drive a Harley in America
Drive a Formula 1 Car
Drive a Hummer
Drive a Luxury Car
Drive a Dog-Sled
Drive an Aston Martin
Ride a Motorcycle
Eat Ice Cream Like a Kid
Experience a White Christmas
Eat in a Celebrity Restaurant
Experience Snowfall
Try Go-Karting
Fill my Wardrobe
Dress Up for a Halloween Party
Finish an Entire Coloring Book
Find a Stick Bug
Sing Karaoke

# Creative Bucket Ideas
Act in a Movie That Hits Theaters Nationwide
Act in a Short Film
Act in a Play
Appear in a Music Video
Appear As an Extra in a Period Drama
Appear in a News Article on TV
Appear on Television
Appear in a YouTube Video That Has Over 1M Views
Be a Model in a Photoshoot
Try a New Recipe Once a Month For a Year
Be a Part of Fashion Week
Be on More Than 4 TV Shows
Be a Probation Officer
Be Proficient in Guitar
Hear a song I wrote play on the Radio
Become Great at Playing Guitar
Build a Bed
Build a Bamboo House
Build a Blanket Fort
Build a Bedside Table
Build a Book Christmas Tree
Build a Classical Music Library
Build a Classic Car
Build a Computer
Build a Collection of Art
Build a Darkroom
Build a Doll House
Build a Disc Golf Course
Build a Full-Sized Greenhouse
Build a Fountain at the Entrance to my House
Build a Functioning Solar Still
Build a Giant Sand Castle
Build a Giant Playground
Build a Greenhouse
Build a Gingerbread House
Build a Herb Garden
Build a Huge Lego Model
Build a House in the Bush
Build a Man-Cave in the Basement
Build a Log Cabin
Build a New Type of Engine
Build a Puzzle
Build a Piece of Furniture
Build a Sauna in my Home
Build a Record Collection
Build a Tree House
Build an Outdoor Kitchen
Build a Website
Build Something
Build a Doll House
Build a Home Computer System
Build a Small Dance Studio
Build A Major Brand
Build a Youth Ministry
Build a Well
Build Affordable Green Communities
Choreograph a Dance For Someone Famous
Choreograph a Contemporary Ballet
Complete a Painting in One Day
Choreograph a Music Video
Complete a Recipe Book Project
Write the Music and Lyrics for a Song
Complete a Wine Journal
Cover a Song on YouTube
Convert a Double-Decker Bus into a Motor Home
Cover my Bedroom Walls Completely in Photos
Cover my Ceiling in Glow in the Dark Stars
Cover my Bedroom Walls with Lyrics
Create a Board game
Create a Blog
Create a Bow and Arrow
Create a College Photo Album
Write a Children's Book
Create a Computer Game
Make a Compost Bin
Create a Documentary
Create a Wall of Polaroids
Create a New Ice Cream Flavor
Make a Scrapbook
Create a Publication
Create a Sports Car that is Environmentally Friendly
Make a Video that Goes Viral on YouTube
Create a Unique Art Form
Create an Android Application
Create a Virtual Presence
Create an Art Piece Based on a Song
Design an Entirely New Fashion Style
Create an Artistic Masterpiece
Create an iPhone Application
Create an Exhibition
Create Health Food
Make my Own Candy
Make Melted Crayon Art
Create my Own Fragrance
Create my Own Drink
Create my Own Library of Books and Movies
Create my Own Milk Shake
Design my Own Line of Socks
Decorate a House
Design my Own Shirt

# Crazy Bucket Ideas
Base Jump with a Wingsuit
Go Bungee Jumping
Go to the Top of the Tallest Building in the World
Cage Dive with Sharks
Come Face to Face with a Tiger
Cage Dive with Crocodiles in Darwin
Capture a Tornado on Film
Capture a Fugitive
Chase a Tornado
Cave Dive
Circumnavigate the Globe By Sail
Cliff Dive into Water
Go Cliff Diving
Climb a Volcano
Climb 5 Mountains
Climb a Water Tower
Climb an Iceberg
Climb a Waterfall
Climb to the Top of Kale Fortress in Skopje
Climb to the Top of a Rope in a Gym
Climb to the Top of Orton Hall
Walk on Hot Coals
Climb Up to the Statue of Christ the Redeemer in Rio
Cross a Country by Bicycle
Cross a Country on Foot
Cross a Glacier on Foot
Deliver a Baby
Crowd Surf at a Rock Concert
Go on a Submarine
Cage Dive with Great Whites
Dive a Shipwreck
Dive Under Ice
Dive to the Titanic
Do a Bungee Race
Dive or Snorkel with Whale Sharks
Do a Firewalking
Do a Polar Bear Plunge
Do a Human Suspension Free Fall
Go Skydiving
Do a Polar Bear Swim
Do a Tandem Parachute Jump
Do a Reverse Bungee Jump
Go Human Bowling
Do the World's Highest Bungee Jump
Do Something Insanely Brave
Don't Sleep For 48 Hours
Drive a Race Car on a Race Track
Drive 200+ Kph on the German Autobahn
Eat Bugs
Drive a Rally Car
Eat Bull Testicles
Eat Iguana
Eat Frog Legs
Eat Something Foreign That Looks Disgusting
Eat Snake
Experience a Tandem Paragliding
Experience Four Different Extreme Environments
Experience a Very Mild Earthquake
Feed Sharks
Experience Weightlessness
Fly a Wingsuit
Go at the Top of the Highest Building of the World
Go Alligator Hunting
Go Bobsledding
Go Base Jumping
Go Bull Riding
Go Cliff Diving
Go Cave Jumping
Go Go-Karting
Go Dog Sledding
Go Heliboarding
Go Indoor Skydiving
Go Helmet Diving
Go Into Space
Go Into a Zero Gravity Room
Go on a Zipline Tour
Go Paragliding
Go Parachute Jumping
Go Para-Skiing
Go Parasailing
Go Pearl Diving
Go Rappelling
Go Quad biking
Snorkel around a Shipwreck
Go Red Back Spider Hunting
Go Storm Chasing
Go Volcano Boarding
Dive the Great Barrier Reef
Go Wind Surfing
Go White Water Rafting
Go Zip-Lining
Hang Glide
Go Zorbing
Hold a Dangerous Snake Around my Neck
Have a Nascar Experience
Hold a Tarantula
Jump from a High Place
Hold a Venomous Snake
Jump in a Fountain
Jump from an Airplane

# Cool Bucket Ideas
Arrive at an Airport and Take a Flight Randomly
Go to a Beach Party
Go to a Bonfire at the Beach
Attend a Mind Reading Show
Go to a Beard and Mustache Competition
Attend a Nudist Event
Go to an Overseas Cooking School
Attend an Event at Buckingham Palace
Go to the Winter Olympics
Go to Wimbledon
Bathe In Chocolate
Bathe in Oil
Bathe in Milk
Be a Contestant on a Game Show
Voice a Cartoon Character
Be a Couchsurfing Host
Be a Groupie
Join a Flashmob
Be a Member of a TV Audience
Be a Matchmaker
Be a Sex Symbol
Be a Vintage Model for a Day
Be a Street Performer for a Day
Be a YouTube Star
Voice a Cartoon Character in a Movie
Be an Artist an Live from my Art
Be Awake for 24 Hours
Be an Extra in a TV Show or Movie
Be Handcuffed
Be Goth for a Day
Be in 5 Magazines
Be in a Disney Parade
Be in a Blizzard
Go Inside an Igloo
Be in Two States at Once
Be Interviewed By Jay Leno
Be Invited to the Playboy Mansion
Be Interviewed by Oprah
Be Listed as One of People Magazine's Top 25 Sexiest Men Alive
Be Listed as One of People Magazine's Most Beautiful People
Be Naked in a Rainforest
Take a 24-hr Flight
Go to a Nude Beach
Be on a Radio Show
Be on the Cover of a Magazine
Be on the Cover of Rolling Stone Magazine
Be on a Webcam with Someone for 24 Hours
Be on the Front Page of a Major Newspaper
Be Smiling in the Background of a Random Person's Photo
Be Photographed Beside the Pyramids of Giza
Become Ambidextrous
Bend a Spoon with my Mind
Join a Secret Society
Blow Bubbles in the Rain
Take a Black Taxi Ride in London
Book a Commercial Flight to Space
Visit the Danakil Depression
Book a Titanic Dive Tour
Buy Someone's Groceries Just Because
Bum Around the USA in a Van
Call Someone, Tell Them to Look Out Their Window, and Be Standing on Their Front Lawn
Cartwheel Along the Golden Gate Bridge
Race Camels in the Desert
Change Clothing in a Phone Booth
Celebrate my Birthday in Another Country
Change my Name
Climb a Coconut Tree Barefoot
Chew Khat
Collect 50 Shotglasses
Climb a Light House
Collect a Coin from Every Country I Visit
Collect a Penny For Every Year I've Lived
Collect a Jar of Dirt from Every State
Collect Sand from 5 Countries
Collect Autographs from all my Favorite People
Color my Hair Blue
Cover a Car in Post-it Notes
Complete the IMDB Top 250 Movies
Create a World Map with Pins of Where I've Been
Crash a Party
Cross Abbey Road Crosswalk in London
Dine at Sanyou Cave Hanging Cliff Restaurant, China
Dance all Around the World
Discover the Lost City of Atlantis
Dine in the Eiffel Tower
Do a New Year Dip
Do Everything with my Non-Dominant Hand for a Whole Day
Do a Pole Dance Strip Tease
Do Something Unexpected
Do Something Absolutely Spontaneous
Don't Talk for a Whole Day
Draw Funny Faces on all the Eggs in my Fridge
Don't Use Your Phone for a Day
Drink 10 Different Cocktails
Say 'Yes' to Everything for a Day
Drink a $200 Bottle of Wine
Dye my Hair Purple
Drive More Than 100,000 km in One Year
Eat Exotic Game Meat
Dye my Clothes

; ------------------------------------------------------------------------------
; Source: https://fullylived.com/cool-bucket-list-ideas/

# Cool Bucket List Ideas
Arrive at an Airport and Take a Flight Randomly
Attend a Beach Bonfire
Attend a Beach Party
Attend a Beard and Mustache Competition
Attend a Mind Reading Show
Attend a Nudist Event
Attend an Event at Buckingham Palace
Attend an Overseas Cooking School
Attend Wimbledon
Attend Winter Olympics
Bathe In Milk
Bathe In Chocolate
Bathe In Oil
Be a Cartoon Voice
Be a Contestant on a Game Show
Be a Couchsurfing Host
Be a Flashmobber
Be a Groupie
Be a Matchmaker
Be a Member in the TV Audience
Be a Sex Symbol
Be a Street Performer For a Day
Be a Vintage Model For a Day
Be a Voice in a Cartoon Movie
Be a YouTube Star
Be an Artist an Live from my Art
Be an Extra in a Television Show
Be Awake For 24 Hours
Be Gothic For a Day
Be Handcuffed
Be in 5 Magazines
Be in a Blizzard
Be in a Disney Parade
Be in Two States at Once
Be Inside an Igloo
Be Interviewed By Jay Leno
Be Interviewed On Oprah
Be Invited to the Playboy Mansion
Be Listed As One of People Magazine's Most Beautiful People
Be Listed As One of People Magazine's Top 25 Sexiest Men Alive
Be Naked in a Rainforest
Be Nude on a Nude Beach
Be on a Plane For 24 Hours
Be on a Radio Show
Be on the Cover of a Magazine
Be on the Cover of Rolling Stone Magazine
Be on the Front Page of a Major Newspaper
Be on Webcam With Someone For Twenty Four Hours
Be Photographed Beside the Pyramids of Giza
Be Smiling in a Random Persons Photo in the Back
Become Ambidextrous
Belong to a Secret Society
Bend a Spoon With my Mind
Black Taxi Ride in London
Blow Bubbles in the Rain
Book a Commercial Flight to Space
Book a Dive to the Titanic
Box a Kangaroo
Bum Around America in a Van
Buy Someone's Groceries Just Because
Call Someone, Tell Them to Look Out Their Window, and Be Standing on Their Front Lawn
Camel Race in the Desert
Cartwheel Along the Golden Gate Bridge
Celebrate my Birthday in Another Country
Change Clothing in a Phone box
Change my Name
Chew Khat
Climb a Coconut Tree Barefoot
Climb a Light House
Collect 50 Shotglasses
Collect a Coin from Every Country I Visit
Collect a Jar of Dirt from Every State
Collect a Penny For Every Year I've Lived
Collect Autographs from all my Favorite People
Collect Sand from 5 Countries
Color my Hair Blue
Complete the IMDB Top 250 Movies
Cover a Car in Post-It's
Crash a Party
Create a World Map With Pins of Where I've Been
Cross Abbey Road Crosswalk in London
Dance all Around the World
Dine at Sanyou Cave Hanging Cliff Restaurant, China
Dine in the Eiffel Tower
Discover the Lost City of Atlantis
Do a New Year Dip
Do a Strip Tease on a Pole
Do Everything With my Left Hand For a Whole Day
Do Something Absolutely Spontaneous
Do Something Unexpected
Don't Talk a Whole Day
Don't Use the Phone For a Day
Draw Funny Faces on all the Eggs in my Fridge
Dress a Man
Drink 10 Different Cocktails
Drink a $200 Bottle of Wine
Drive More Than 100,000 Km in One Year
Due my Hair Purple
Dye my Clothes
Eat a Crocodile Meat
Eat a Deep Fried Oreo
Eat a Deep-Fried Mars Bar
Eat a Fish I Caught Myself
Eat an Ostrich Egg
Eat Anything from the Street Food Stalls
Eat at a 5 Star Restaurant
Eat at a Restaurant By Myself
Eat at a Revolving Restaurant
Eat at an Undersea Restaurant
Eat at the Real Soup Nazi
Eat Breakfast at a Dinner
Eat Every Edible Fruit in the World
Eat Everything Off of the 100 Foods to Eat Before You Die List
Eat Everything on BBC's 50 Things to Eat Before You Die List
Experience 25 Different Modes of Transportation
Explore an Abandoned Amusement Park
Explore an Underground Cave
Fast For 40 Days - No TV
Fast For 48 Hours
Fast For a Day
Fast For Three Days
Feed a Homeless
Feed a Kangaroo
Feed a Wallaby
Feed Dolphins
Feel Comfortable Skinny Dipping in Hot Springs
Fill all the Pages in my Passport
Find a Unicorn
Find a Word That Rhymes With Orange
Find Nemo
Fire a Paintball Gun
Fit Into One of my Moms' Outfits As an Adult
Fly a Biplane
Fly a Helicopter
Fly a Plane Over the Ocean
Fly As a Passenger in a Fast Jet
Fly in a Glider
Fly in a Helicopter
Fly to Mars
Fly Virgin Galactic
Fold 1000 Paper Cranes
Follow a Random all Day
Forge a Tool in a Smithy
Get a Belly Button Piercing
Get a Body Piercing
Get a Cat and Name It Dog
Get a Driver's License For Motorcycle
Get a Half-Sleeve Tattoo
Get a Henna Tattoo
Get a Hot Shave at a Barber
Get a Hug from a Monkey
Get a Nose Piercing
Get a Pedicure
Get a Photo With Someone Famous
Get a Range Rover
Get a Secret Tattoo
Get a Star Named After Me
Get a Thai Massage
Get an Autograph from my Favorite Singer
Get in the Guinness Book of World Records
Get my Chakras Aligned
Get Picked Up at the Airport By Someone With a Sign With my Name on It
Get Retweeted By a Celebrity
Get Slapped in the Face
Give a Stranger a Valentine Card
Give Fifty Euros to a Bum
Give Flowers to a Stranger
Give 'Free Hugs' in a Public Place
Give Up Smoking
Go a Week Without Candy
Go a Whole Day Without Talking
Go Bar Hoping
Go Barhopping Dressed As Nuns
Go Bear Hunting
Go Behind the Scenes to the Making of Any Movie
Go Black Friday Shopping!
Go Cheese Tasting
Go Cloud Watching
Go Couch-Surfing
Go Fly-fishing
Go For a Hot Air Balloon Ride
Go For a Medical Mission
Go For a Segway Ride
Go For Picnic
Go Ghost Hunting
Go Glamping
Go Grape Stomping
Go Guerilla Gardening
Go Horse Back Riding
Go Hunting
Go Ice Fishing
Go Ice Skating on a Frozen Lake
Go in a Hot Tub Outside During Winter
Go in a Sauna
Go in a Submarine Ride
Go in Pajamas to the Movies
Go on a Huge Shopping Spree
Go Out in Public Dressed Like a Boy
Go People-Watching
Go See a All-Blacks Rugby Match Live
Go Skinny Dipping at Midnight
Go Swimming in a Pool, Fully Clothed
Go to a 24-Hour Shop at 3 Am
Go to a Nudist Beach
Go to a Restaurant Without Underwear
Go to a Strip Club
Go to a Swingers Club
Go to all 50 US States
Go to all of the U.S. National Parks
Go to all the Monopoly Properties
Go to an Indian Wedding
Go to at Least 1 Country in all 7 Continents
Go to CSI Experience
Go to the Top of the World's Tallest Building in Dubai
Go Up the Escalators the Wrong Way
Go Wwoofing
Grow a Beard
Grow a Field of Sunflowers
Grow a Massive Big Old Beard
Grow my Hair Long
Grow my Hair Out to my Waist
Grow my Own Coffee Beans
Hail a Taxi in NYC
Hand Write and Send Anonymous Letters
Hang Out With a Chimpanzee
Have a Casual Conversation With Someone Famous
Have a Drink in Every County in Ireland
Have a Food Fight
Have a Glow Stick Fight
Have a Headbanging Competition
Have a Lucid Dream
Have a Race on a Segway
Have a Two Finger Ring
Have a Walk-In Closet
Have a Well-Stocked Pantry
Have Afternoon Tea in an Expensive Hotel
Have an Upside Down Christmas Tree
High Five a Stranger
Hit on a Stranger
Hit Someone in the Face With a Pie
Hold a Baby Chicken
Hold a Baby Leopard
Hold a Baby Monkey
Hold a Catfish
Hold a Pit Bull Puppy
Hold a Pot Luck
Hold a Sign Saying 'Talk to Me About Anything' on a Busy Sidewalk
Hold Up a Free Hugs Sign
Host a Couchsurfer
Host a Lolita Tea Party
Hug a Baby Elephant
Hug Everyone at a Party
Join a Mastermind
Join a Secret Society
Join a Singing Team
Join a Toastmasters Club
Join the Mile High Club
Join the Polar Bear Club
Join the Sioux Indian Tribe
Jump Out of a Cake
Kick in a Door
Kiss a Frog
Kiss a Stranger
Kiss the Blarney Stone
Laugh all the Way to the Bank
Laugh Daily
Laugh Till I Cry
Laugh Till my Face Hurts
Lay in a Street in the Middle of the Night
Leave $100 Tip
Leave a Note in a Library Book
Leave a Note on Somebody's Car Window
Leave a Shoe at a Ball
Leave Cookies on a Stranger's Doorstep
Leave Flowers on Someone's Doorstep
Leave my Mark on the World
Let a Snowflake Land on my Tongue
Let Go of a Floating Lantern
Let my Hair Get Really Long
Let Someone Cut my Hair However They Want
Let Someone Order a Meal For Me
Light a Cigar With a $100 Bill
Live By the Ocean
Live Communally
Live Forever
Live in a House Inspired By Japanese Architecture
Live in a House With a Fireplace
Live in a House With an Inner Courtyard
Live in a House With Secret Doors
Live in a Mansion
Live in a Very Small Town For a Year
Live in a Zero-Energy House
Live on a Beach For a Month
Live on a Boat
Live One Year Without Electricity
Live Right By the Beach
Mail a Banana
Mail a Secret to Postsecret
Make $5 all in a Day, Just from Recycling Cans and Bottles
Make a Complete and Utter Fool of Myself
Make an Igloo and Live in It For a Week
Make an Important Decision With a Coin Toss
Meet a Geisha in Kyoto
Milk a Cow
Milk a Goat
Mush a Dog Sled
Name a Star
Name my Furniture
Name Something After a Disney Character
Not Waste a Single Grocery Item For at Least 3 Months
Nude Night Surfing
Nutella Battle
Order Dinner in Reverse Order
Order Pizza and Send It to a Random House
Own 100 Pairs of Shoes
Own a 1St Edition Comic Book
Own a Bentley
Own a Blueberry Farm
Own a BMW
Own a Cat Like Garfield
Own a Condo in New York City
Own a Convertible
Own a Dance Studio in New York
Own a Harley-Davidson
Own a House in a Foreign Country
Own a Jellyfish Aquarium
Own a Large Book Collection
Own a Mini
Own a Pair of Designer Heels
Own a Professional Football Team
Own a Range Rover
Own a Vacation Home
Own a Victoria Secret Bikini
Own a Vintage Automobile
Own a Walk-In-Closet
Own a Whirlpool Bathtub
Own a White Kitten
Own a Yacht
Own an Antique Typewriter
Own an Armani Suit
Own an English Bulldog
Own Designer Heels
Own Leather Boots
Own my Own Comic Shop
Own my Own Company Within 5 Years
Own my Very Own Vespa
Own Recording Studio
Own Season Tickets
Pan For Gold in a Mountain Stream
Participate in a Fight
Participate in a Regatta
Participate in a Riot
Participate in a Tomato Battle
Participate in a Water Fight
Participate in a Zombie Walk
Participate in Burning Man
Participate in Nanowrimo
Participate in the Bull Run in Spain
Party all Night Without Stopping For Sleep
Party on a Yacht
Perform a Dance in Disney World
Pet a Baby Cougar
Plant a Gnome in my Neighbors Garden
Plant a Tree and Paint It Pink
Play a Didgeridoo
Play a Game of Monopoly With Real Money
Play a Game of Strip Chess
Play a New Sport For an Entire Season
Play Golf in 50 Different Countries
Play in a Human Hamster Ball
Play in a Poker Tournament
Play on the World Highest Tennis Court in Dubai
Pledge a Fraternity
Pretend to Be a Window Mannequin
Pretend to Be Rich in Monaco
Pretend to Not Speak English in Public
Prove a Theory
Pull a Fire Alarm
Pull an all Nighter
Put a Pair of my Shoes on a Shoe Tree
Put a Random Item in Someone's Shopping Cart
Put Mentos in Coke
Put my Hand Print Into Wet Concrete
Put my Mouth Under an Ice Cream Machine
Put on an Accent and Convince a Stranger I'M from That Place
Put Soap in a Public Fountain
Randomly Select a Book from the Library and Read It
Rate Every Single Beatles Song
Reach all Six Provinces of the Bicol Region
Receive a Knighthood
Receive a Postcard from all 247 'Countries' from Postcrossing
Receive a Standing Ovation
Release a Chinese Lantern
Rent a Flashy Car For a Day
Request a Song on the Radio
Ride a Camel
Ride a Dirt Bike
Ride a Double Decker Bus
Ride a Ducati
Ride a Harley Davidson
Ride a Horse on the Beach at Sunrise
Ride a Hot Air Balloon
Ride a Jet Ski
Ride a Limo
Ride a Mattress Down the Stairs
Ride a Mechanical Bull
Ride a Segway
Ride a Subway
Ride a Tandem Bike
Ride a Unicycle
Ride an Elephant
Ride an Ostrich
Ride an Upside Down Roller Coaster
Ride Every Single Ride at a Theme Park
Ride in a Fire Truck
Ride Kingda-Ka
Ride on a Bob
Ride on a Ferry
Ride on a Velodrome Track
Ride on the Back of a Motorcycle
Ride the Fastest Roller Coaster
Ride the Scooters in Walmart
Ride the Ten Largest Roller Coasters in the World
Ring a Church Bell
Rock the Drums in Front of a Big Audience
Roll Around in Mud in my Wedding Dress
Run Around NYC in a Rat Costume
Run Naked in the Snow
Scare a Huge Group of Pigeons
Scare my Husband
See a Baseball Game at Every Pro Baseball Field
See a Cheetah Run
See a Drag Show
See a Live Red Panda
See a UFO
See all "100 Places to See Before You Die"
Send a Letter to a Random Address
Send a Message in a Bottle
Send a Postcard Through Postcrossing
Share a Pet
Shave all the Hair Off my Body
Shoot a Gun
Shoot an Arrow
Shop at Harrods
Shop With a Personal Assistant
Shower in a Waterfall
Shroom in the Forest
Sing a Bohemians Prague Song For 34 Minutes Straight
Sit in an Outdoor Hot Tub During Winter
Sit on a Bench and Rate the People Who Pass By
Skinny Dip at Midnight
Sleep all Night in a Hammock
Sleep on a Beach
Sleep on a Boat
Sleep on an Air Mattress Floating in Water
Sleep Under the Stars
Slow Dance in the Rain
Smash a Guitar
Smash a Watermelon
Smoke a Cuban Cigar
Snow Fight
Spend 24 Hours Naked
Spend a Day at a Health Center
Spend a Day at the Movies
Spend a Night at the World's Most Expensive Hotel
Spend the Night in an Underwater Hotel
Spend the Night on a Football Field
Spend the Night on a Pirate Ship
Spin Around on an Escalator
Stand at the Equator
Stand in the Middle of Stonehenge
Stand in the Sistine Chapel
Stand on an Alaskan Glacier
Stay Awake all Night
Stay in a Lighthouse
Stay on a Private Island
Stay on an Indian Reservation
Stick my Toes in Every Great Lake
Sunbath in the Rain
Swap Houses For a Vacation
Swap Places With Someone For a Day
Swim from Asia to Europe Across the Bosporus Strait
Swing from a Rope Into a Lake
Take a Bath in Skittles
Take a Bath in Syrup
Take a Crying Photo
Take a Mud Bath
Take a Nap in a Furniture Store
Take a Ride on a Fighter Jet
Take an Outdoor Shower
Take Care of an Animal
Talk in a British Accent For a Day
Talk in a Different Voice When I Meet Someone New
Talk in a Southern Accent For a Straight Hour With a Friend
Testify Before the Un
Text a Random Mobile Number and Wish Them a Good Day
Think of Phrases to Say Before I Die
Throw a Drink in Someone's Face
Throw Water Into the Air and Watch It Freeze
Touch all the 1,000 Buddhas in Hong Kong
Try 50 Cocktails
Try 50 Different Kinds of Beer
Try a Food You Can't Pronounce
Try a Fried Snickers
Try all of Omnivore's Top 100
Try all Types of Chocolate
Try Bubble Tea
Try Every Ben & Jerry's Ice Cream Flavor
Try Every Kind of Beer in Germany
Try Food Eaten By Astronauts
Try Foods I Normally Wouldn't
Try Fried Oreos
Try Fried Twinkies
Try Frog's Legs
Try Haggis in Scotland
Try Helium
Try One Exotic Food a Day For a Month
Try White Hot Chocolate
Use a Fake Name at Starbucks
Visit 10 Capital Cities
Visit 100 Wineries
Visit 12 South American Countries
Visit 15 Attractions of the Unesco World Heritage List
Wake Up on a Beach
Walk Around a Give Away $1 Bills
Walk Barefoot in the Rain
Walk Down a Red Carpet
Walk on a Beach By Moonlight
Walk on a Glacier
Walk on Hot Coals
Walk on Stilts
Walk Through Central Park in the Snow
Walk Through Japans Tunnel of Lights
Walk Up to a Random Guy on the Street and Kiss Him
Wash the Car With Water Balloons
Watch 1000 Movies
Watch 26 Movies I've Never Seen Starting With Each Letter of the Alphabet
Watch 365 Movies in a Year
Watch a Blue Man Group Show
Watch a Desperate Housewives Marathon
Watch a Movie in 3D
Watch a Movie in Fresh Air
Watch a Super-Nova Explosion
Watch all of the James Bond Movies
Watch all of the Star Wars Movies
Watch all the Harry Potter Movies
Watch Casablanca in Casablanca
Watch Every Episode of Seinfeld
Watch Every Movie That Has Been Directed By Steven Spielberg
Watch Every Oscar Winning Best Picture
Watch Fireworks from a Boat on a Lake
Watch Rocky Horror at a Midnight Showing
Watch the Nobel Prize Ceremonies
Watch the Sun Set at the Top of a Mountain
Wear a Blindfold For a Day
Wear a Classy Dress & Heels in Public
Wear a Complete Suit of Armor
Wear a Fuzzy Hat in Russia
Wear a Shirt That Says "Life" and Hand Out Lemons to People
Wear a Wig For a Day
Wear an Authentic Kimono in Japan
Wear an Outrageous Halloween Costume and Own the Night
Wear Colored Contacts
Wear Fake Eyelashes
Wear Guy Clothes to the Mall
Wear my Hair in Dreadlocks
Win a Drinking Game
Write 365 Letters to Someone
`
